import moment from "moment";

/**
 * @param {string} settingsJsonString
 * @return {TimelineSettingsDefs.Settings}
 */
function parseSettings(settingsJsonString) {
	/**
	 * @type {TimelineSettingsDefs.Settings}
	 */
	const settings = JSON.parse(settingsJsonString);

	// Parse exceptions dates into moment instances
	settings.workableDaysExceptions.forEach(exception => {
		// At this point they are still date strings so we need to turn them into
		// moment instances
		exception.start = moment(exception.start, 'YYYY-MM-DD');
		exception.end = exception.end ? moment(exception.end, 'YYYY-MM-DD') : undefined;
	})

	return settings;
}

export {parseSettings}
